import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Building2 } from "lucide-react";

export const NoClientsState = ({ isAgency }) => {
  const navigate = useNavigate();
  return (
    <div className="flex flex-col items-start gap-4 max-w-md py-16" data-testid="no-clients-state">
      <div className="w-11 h-11 rounded-xl bg-primary/15 flex items-center justify-center"><Building2 className="w-5 h-5 text-primary" /></div>
      <h2 className="text-2xl font-display font-bold">{isAgency ? "Add your first client" : "No clients assigned yet"}</h2>
      <p className="text-sm text-muted-foreground">
        {isAgency
          ? "Everything in Momento (contacts, pipelines, workflows and calls) lives inside a client workspace. Create one to get started."
          : "Ask your account owner to give you access to a client in Settings → Team. You'll see their workflows and contacts here as soon as they do."}
      </p>
      {isAgency && <Button onClick={() => navigate("/settings?tab=clients")} data-testid="no-clients-create-button">Create a client</Button>}
    </div>
  );
};
